import { clsx } from "clsx";
import { ButtonBase } from "@/components/ui/ButtonBase";
import { ButtonProps } from "./ButtonProps";
import classes from "./Button.module.scss";

export function Button(props: ButtonProps) {
  const {
    children,
    className,
    variant = "default",
    size = "medium",
    ref,
    ...buttonProps
  } = props;

  const rootClassName = clsx(className, classes.button, {
    [classes.outlined]: variant === "outlined",
    [classes.default]: variant === "default",
    [classes.small]: size === "small",
    [classes.large]: size === "large",
  });

  return (
    <ButtonBase className={rootClassName} ref={ref} {...buttonProps}>
      {children}
    </ButtonBase>
  );
}
